import queryString from "query-string";

import API from "../index";
import getDeviceType from "../helpers/getDeviceType";
import {cxApiParams} from "../../../config";
import {includes, path} from "ramda";
import {Token} from "./entities";
import queryClient from "../../queryClient";

const AUTH_ERROR_CONTACT_CUSTOMER_SUPPORT =
  "auth.obtain_access_token.force_contact_customer_support";
const AUTH_ERROR_FORCE_PASSWORD_RESET =
  "auth.obtain_access_token.force_password_reset";

const createAnonymousToken = () =>
  API.Auth.createToken(
    {},
    {
      headers: {
        Authorization: `Basic ${window.btoa(`${cxApiParams.anonClientId}:`)}`,
      },
      data: "grant_type=client_id",
    }
  );

const createAuthenticatedToken = () =>
  API.Auth.createToken(
    {},
    {
      headers: {
        Authorization: `Basic ${window.btoa(
          `${cxApiParams.accountAuthClientId}:`
        )}`,
      },
      data: queryString.stringify(
        {
          grant_type: "etp_rt_cookie",
          device_type: getDeviceType(),
        },
        {skipNull: true}
      ),
    }
  );

const getToken = () =>
  createAuthenticatedToken()
    .catch(error => {
      if (
        includes(path(["data", "code"], error), [
          AUTH_ERROR_CONTACT_CUSTOMER_SUPPORT,
          AUTH_ERROR_FORCE_PASSWORD_RESET,
        ])
      ) {
        throw error;
      }
      return createAnonymousToken();
    })
    .then(Token);

const getAccessToken = () =>
  queryClient.fetchQuery({
    queryKey: ["token"],
    queryFn: getToken,
    staleTime: 3600 * 1000,
  });

export {getAccessToken};
